module.exports = __webpack_public_path__ + "assets/img/slide05.5097c043.svg";